import { AxiosResponse } from 'axios';

import { SalespersonInfo } from 'actions/data';

import { HttpClient } from './HttpClient';

export interface IntermediarySuggestionDto {
  id: string;
  variables: IntermediarySuggestionVariables;
}

interface IntermediarySuggestionVariables {
  intermediary_name?: null | string;
  intermediary_salespersons?: SalespersonInfo[] | null;
}

export interface GetIntermediariesSuggestionsDto {
  name: string;
}

export default class IntermediariesApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/intermediaries' || '');
  }

  public async getSuggestions({ name }: GetIntermediariesSuggestionsDto) {
    return this.instance
      .get(`/suggestions?name=${encodeURIComponent(name)}`)
      .then((response: AxiosResponse<IntermediarySuggestionDto[]>) => response.data);
  }

  public async verify(id: string) {
    return this.instance
      .get(`/verify?id=${encodeURIComponent(id)}`)
      .then((response: AxiosResponse<boolean>) => response.data);
  }
}

export const intermediariesApi = new IntermediariesApi();
